import { PriorityOptions } from '../components/TaskTable/helpers/helper';
import Task from '../types/Task';
import { TaskDependencies } from '../types/TaskDependency';
import Workspace, { WorkspaceFramework } from '../types/Workspace';
import { AnalyticsTaskCompletedPropertiesType } from './analyticsEvent';

/**
 * Properties for app.task.completed.
 *
 * blockedBy / blocking come from `dependencies` when the caller has them loaded, otherwise from
 * the edges on the task record. A record without edges (not every payload carries them) leaves
 * both out rather than reporting a task as unblocked.
 */
export const taskCompletedProperties = (
  task: Task,
  workspace?: Workspace,
  dependencies?: TaskDependencies
): AnalyticsTaskCompletedPropertiesType => {
  const blockedByCount = dependencies ? dependencies.blockedBy.length : task.BlockedByEdges?.length;
  const blockingCount = dependencies ? dependencies.blocking.length : task.BlockingEdges?.length;
  // The task's own space, even when its workspace is not cached (All Tasks). The org is sent
  // only when the workspace passed is that space; undefined keeps analytics.track from filling
  // in the org of whichever space was open last.
  const spaceId = task.workspaceId ?? workspace?.id;
  const organizationId = workspace && workspace.id === spaceId ? workspace.organizationId : undefined;
  return {
    taskId: task.id,
    taskType: task.parentTaskId ? 'subitem' : 'item',
    organizationId,
    spaceId,
    stage: workspace?.framework === WorkspaceFramework.kanban ? 'kanban' : task.stage,
    ...(blockedByCount !== undefined ? { blockedBy: blockedByCount > 0 } : {}),
    ...(blockingCount !== undefined ? { blocking: blockingCount > 0 } : {}),
    epic: !!task.epicId,
    owner: !!task.assignee,
    startDate: !!task.startDate,
    targetDate: !!task.deadline,
    priority: task.priority !== PriorityOptions.NoPriority,
    estimate: !!task.estimate,
    subitem: !task.parentTaskId && (task.subtasks?.length ?? 0) > 0,
    label: (task.TaskLabels?.length ?? 0) > 0,
  };
};
